import { ApiTask } from '@/entities/task/api/tasksApi'
import { TaskItem } from '@/entities/task/model/taskTypes'
import { transformApiTaskToTaskItem } from '@/entities/task/lib/transformTask'

export const fetchAndTransformTasks = async (
  fetchFn: () => Promise<ApiTask[]>
): Promise<TaskItem[]> => {
  const apiTasks = await fetchFn()

  return apiTasks
    .map((apiTask) => transformApiTaskToTaskItem(apiTask))
    .filter((task): task is TaskItem => task !== null)
    .sort((a, b) => b.number - a.number)
}
